import { Separator } from '@/components/atoms/Separator';
import { Skeleton } from '@/components/atoms/Skeleton';
import ListagemConteudosFallback from '@/components/organisms/ListagemConteudos/fallback';
import ListagemTitulosFallback from '@/components/organisms/ListagemTitulos/fallback';
import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function RecomendadosPaginaDesktopFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Skeleton style={{ height: 32 }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: `${theme.spacing[5]}px ${theme.spacing[8]}px`,
          gap: theme.spacing[8],
          maxWidth: breakpointDesktopDefault.maxWidth,
          margin: breakpointDesktopDefault.margin,
        }}
      >
        <ListagemTitulosFallback />
        <ListagemTitulosFallback />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[7],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[5],
            }}
          >
            <Skeleton style={{ height: 32, width: '30vw' }} />
            <Skeleton style={{ height: 46, width: '36vw' }} />
          </div>
          <ListagemConteudosFallback />
          <div style={{ alignSelf: 'center' }}>
            <Skeleton style={{ height: 38, width: 155 }} />
          </div>
        </div>
        <Separator $block={false} $orientation="horizontal" />
        <ListagemTitulosFallback />
        <ListagemTitulosFallback />
      </div>
    </div>
  );
}
